import React, { useState, useEffect } from 'react';
import './role.css';
import { FaUserTie, FaUser } from 'react-icons/fa'; 
import NationalImg from '../../assets/search-icons/srilanka_map.png';
import { FaFolderTree } from "react-icons/fa6";
import Province from '../../assets/search-icons/province_icon.png';
import Zone from '../../assets/search-icons/zone_icon.png';
import Region from '../../assets/search-icons/region_icon.png';
import Branch from '../../assets/search-icons/branch_icon.png';
import Cluster from '../../assets/search-icons/cluster_icon.png';
import Channel from '../../assets/search-icons/channel_icon.png';
import TM from '../../assets/search-icons/TM_icon.png';

const Role = ({ roles, title, onRoleSelect, reset }) => {
  const [selectedRole, setSelectedRole] = useState(null);

  const roleStyles = {
    National: { color: '#81D4FA', icon: <img src={NationalImg} alt="National" width={26} height={26} /> },
    Channel: { color: '#80DEEA', icon: <img src={Channel} alt="Channel" width={24} height={24} /> },
    'Sub Channel': { color: '#B2EBF2', icon: <FaFolderTree /> },
    Cluster: { color: '#C8E6C9', icon: <img src={Cluster} alt="Cluster" width={24} height={24} /> },
    Province: { color: '#A5D6A7', icon: <img src={Province} alt="Province" width={24} height={24} /> },
    Zone: { color: '#C5E1A5', icon: <img src={Zone} alt="Zone" width={24} height={24} /> },
    Region: { color: '#9FA8DA', icon: <img src={Region} alt="Region" width={24} height={24} /> },
    Branch: { color: '#D1C4E9', icon: <img src={Branch} alt="Branch" width={24} height={24} /> },
    FD: { color: '#80CBC4', icon: <FaUserTie /> },
    TM: { color: '#CE93D8', icon: <img src={TM} alt="TM" width={24} height={24} /> },
    RSM: { color: '#A5B8E3', icon: <FaUser /> },
    ARSM: { color: '#9FA8DA', icon: <FaUser /> },
    TL: { color: '#81D4FA', icon: <FaUser /> },
    FP: { color: '#4DD0E1', icon: <FaUser /> },
    OC: { color: '#80DEEA', icon: <FaUser /> },

    // Also add designation names with same styles
    'Provincial Manager': { color: '#A5D6A7', icon: <img src={Province} alt="Provincial Managers" width={24} height={24} /> },
    'Zonal Manager': { color: '#C5E1A5', icon: <img src={Zone} alt="Zonal Managers" width={24} height={24} /> },
    'Regional Manager': { color: '#9FA8DA', icon: <img src={Region} alt="Regional Managers" width={24} height={24} /> },
    'Branch Manager': { color: '#D1C4E9', icon: <img src={Branch} alt="Branch Managers" width={24} height={24} /> },
    'Territory Managers': { color: '#CE93D8', icon: <img src={TM} alt="Territory Manager" width={24} height={24} /> },
    'Regional Sales Managers': { color: '#A5B8E3', icon: <FaUser /> },
    'Assistant Regional Sales Managers': { color: '#9FA8DA', icon: <FaUser /> },
    'Team Leader': { color: '#81D4FA', icon: <FaUser /> },
    Advisor: { color: '#4DD0E1', icon: <FaUser /> },
  };

  useEffect(() => {
    if (reset) setSelectedRole(null);
  }, [reset]);

  const handleClick = (role) => {
    setSelectedRole(role);
    onRoleSelect(role);
  };

  // Get style by checking name or designationName keys in roleStyles
  const getStyle = (role) => {
    return roleStyles[role.name] || roleStyles[role.designationName] || { color: '#d9d9d9', icon: <FaUser /> };
  };

  return (
    <div className="role-container">
      <div className="role-title">{title}</div>
      <div className="roles">
        {roles.map((role, idx) => {
          const { color, icon } = getStyle(role);
          return (
            <div
              key={idx}
              className={`role-item ${selectedRole === role ? 'active' : ''}`}
              onClick={() => handleClick(role)}
            >
              <div className="role-icon" style={{ backgroundColor: color, fontSize: 24 }}>
                {icon}
              </div>
              <p className="role-name">{role.name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Role;
